export default {
  necessary: {
    cookie: ["dc"],
  },
};
